import script from "./EmergencyRequestInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./EmergencyRequestInfo.vue?vue&type=script&setup=true&lang=js"

import "./EmergencyRequestInfo.vue?vue&type=style&index=0&id=2181153a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2181153a"]])

export default __exports__